import { useCallback } from 'react';
import { cancelFunctions } from 'utils/cancelFunctions';
import { getContentDealIdLookupData, getLookupData } from 'modules/api/lookups';
import Local from 'modules/Local';
import { HEADERS_CONTENT_TYPE } from 'modules/api/constants';
import { CodeName } from 'components/common/types/CodeName.types';
import { InputValidationConfig } from '../InputWithValidation';

type UseApiHandlers = {
  loadLookupData: (dropdownName: string, query: string, dspCode?: string) => Promise<CodeName[]>;
  createFormData: (dsp: CodeName, externalId: InputValidationConfig, dealId: CodeName[], filesList: File[]) => FormData;
};

export const useApiHandlers = (): UseApiHandlers => {
  const loadLookupData = useCallback(async (dropdownName: string, query: string, dspCode?: string) => {
    if (query.length < 2) return [];

    try {
      if (dropdownName === 'dealId' && dspCode) {
        return await getContentDealIdLookupData(cancelFunctions, Local.getEnvironmentId(), query, dspCode);
      }
      return await getLookupData({ cancelFunctions, lookupURLName: dropdownName, query });
    } catch (error) {
      return [];
    }
  }, []);

  const createFormData = useCallback(
    (dsp: CodeName, externalId: InputValidationConfig, dealId: CodeName[], filesList: File[]): FormData => {
      const param: { auth0Identifier: string; dealId?: string[] } = {
        auth0Identifier: Local.getEnvironmentId(),
        dealId: dealId.length ? dealId.map((d) => d.code) : undefined,
      };

      const payload = {
        externalId: externalId.value.trim(),
        dspCode: dsp.code,
        market: [param],
      };

      const formData = new FormData();
      formData.append('file', filesList[0]);
      formData.append(
        'createCreativeDTO',
        new Blob([JSON.stringify(payload)], { type: HEADERS_CONTENT_TYPE.APPLICATION_JSON }),
      );
      return formData;
    },
    [],
  );

  return { loadLookupData, createFormData };
};
